import { render } from "./BorrowHistoryBody.vue?vue&type=template&id=a2b387dc"
import script from "./BorrowHistoryBody.vue?vue&type=script&lang=js"
export * from "./BorrowHistoryBody.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__